<template lang="">
	<div>
		<div>
			<!-- 副导航 -->
			<c-r-m-nav-cell
				ref="navcell" 
				:crm-type="crmType" 
				route-type="index"/>
				
			<!-- 筛选 -->	
			<div class="shitu-box">
				<c-r-m-list-head
					ref="listHead" 
					:crm-type="crmType" 
					:scene_id="scene_id"
					@on-handle="listHeadHandle"/>
				
				<c-r-m-option-button
					ref="search" 
					:crm-type="crmType" 
					:searchtype="searchtype"
					:actiontype="actiontype"
					:exporttype="exporttype"
					:filter-arr="filterArr"
					:scene_id="scene_id"
					@on-handle="optionHandle"
					@save-handle="saveHandle"
					@on-search="searchHandle"
					@on-height-search="heightSearchHandle"/>	
			</div>
			
			<!-- 信息 -->
			<div v-loading="loading" class="abctable">
				<c-r-m-table-head
					ref="crmTableHead"
					:crm-type="crmType"
					:show-hegiht-search="true"
					:actiontype="actiontype"
					@exportData="exportData"
				    @filter="handleFilter"
					@handle="handleHandle">
				</c-r-m-table-head>
				<el-table
					v-show="!loading"
					id="crm-table"
					:data="list" 
					class="n-table--border"
					:cell-style="cellStyle"
					stripe
					border
					size="mini"
					style="width: 100%"
					:header-cell-style="{'background-color':'#f6faff'}" 
					@row-click="handleRowClick"
					@sort-change="sortChange"
					@selection-change="handleSelectionChange">
					<template slot="empty"> 
						<el-empty 
							description="暂无数据"></el-empty>
					</template>
					<el-table-column
						v-if="fieldList.length > 0"
						show-overflow-tooltip
						type="selection"
						align="center"
						width="45"/>
					<el-table-column
						v-if="fieldList.length > 0"
						width="35"
						show-overflow-tooltip>
						<template
							slot-scope="scope">
							<i 
								v-if="scope.row.isfocus == 1"
								class="el-icon-star-on customer-lock icon"
								@click="focus({is_focus:2,lawcase_id:scope.row.id})"></i>
							<i
								v-else
								class="el-icon-star-off icon"
								@click="focus({is_focus:1,lawcase_id:scope.row.id})"></i>	
						</template>
					</el-table-column>
					<el-table-column
						v-for="(item, index) in fieldList"
						v-if="item.prop == 'name'"
						:key="index"
						:prop="item.prop"
						:label="item.label"
						:formatter="fieldFormatter"
						sortable="custom">
					</el-table-column>
					<el-table-column
						v-else-if="item.prop == 'type'"
						:key="index"
						:prop="item.prop"
						:label="item.label"
						:formatter="fieldFormatter"
						width="105"
						show-overflow-tooltip
						sortable="custom">
						<template slot-scope="scope">
							<el-tag style="width: 70px;" v-if="scope.row['type'] == '非诉咨询'" type="success" effect="light">{{ scope.row['type'] }}</el-tag>
							<el-tag style="width: 70px;" v-else-if="scope.row['type'] == '非诉服务'" type="warning" effect="light">{{ scope.row['type'] }}</el-tag>
							<el-tag style="width: 70px;" v-else-if="scope.row['type'] == '刑事案件'" type="danger" effect="light">{{ scope.row['type'] }}</el-tag>
							<el-tag style="width: 70px;" v-else-if="scope.row['type'] == '诉讼案件'" effect="light">{{ scope.row['type'] }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column
						v-else
						:key="index"
						:prop="item.prop"
						:label="item.label"
						:formatter="fieldFormatter"
						sortable="custom">
						<template
						  slot="header"
						  slot-scope="scope">
						  <div class="table-head-name">{{ scope.column.label }}</div>
						</template>
					</el-table-column>
					<!-- 操作 -->
					<el-table-column
						align="center"
						label="操作"
						width="55"
						v-if="fieldList.length > 0">
							<template slot-scope="scope">
								<el-link
									type="primary"
									v-if="allAuth.lawcase && allAuth.lawcase.read"
									@click="handleAction({'type':'read','data':scope.row})">查看</el-link>
								<el-link
									type="primary"
									v-if="allAuth.lawcase && allAuth.lawcase.update"
									@click="handleAction({'type':'update','data':scope.row})">修改</el-link>
							</template>
					</el-table-column>
				</el-table>
				<div class="p-contianer" v-if="!loading">
					<el-pagination 
						:current-page="currentPage"
						:page-sizes="pageSizes"
						:page-size.sync="pageSize"
						:total="total"
						class="p-bar"
						layout="total, sizes, prev, pager, next, jumper"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"/>
				</div>
			</div>
		</div>
		<!-- dialog弹窗 -->
		<dialog-form
			:dialog-visible="dialogForm"
			:title="title"
			ref="crmform"  
			:crm-type="crmType"
			:fields-data = "fieldsData"
			:action="action"
			:form-data="formData"
			@close = "closeDialog"
			@save-dialog="saveDialog">
		</dialog-form>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'
	import table from '../../mixins/lawcase'
	import { DialogForm } from '@/components/FromData'
	export default {
		name: "app",
		components: {
			DialogForm
		},
		computed: {
			...mapGetters(['allAuth'])
		},
		mixins: [table],
		data() {
			return {
				crmType: 'lawcase',
				
				actiontype:7,
				searchtype:34,
				exporttype:53
			}
		},
		methods: {
			/** 通过回调控制style */
			cellStyle({ row, column, rowIndex, columnIndex }) {
			  if (column.property === 'name' || column.property === 'customer') {
			    return { color: '#3E84E9', cursor: 'pointer' }
			  } else {
			    return ''
			  }
			},
			
			handleAction(item){
				switch (item.type){
					case "read":
						let routeData = this.$router.resolve({ path: "/lawcase/read/basicinfo/"+item.data.id })
						window.open(routeData.href, '_blank')
						break;
						
					case "update":
						let relevant = ''
						let actiontype = ''
						let res = item.data
						if( res.type== '非诉咨询'){
							actiontype = '132'
							relevant='zixun'
							res["feisu_status"] = res["status"];
						}else if(res.type == '非诉服务'){
							actiontype = '142'
							relevant='fuwu'
							res["feisu_status"] = res["status"];
						}else if(res.type == '诉讼案件'){
							actiontype = '152'
							relevant='susong'
							res["susong_status"] = res["status"];
						}else if(res.type == '刑事案件'){
							actiontype = '162'
							relevant='xingshi'
							res["xingshi_status"] = res["status"];
						}
						this.title = "修改信息"
						this.dialogForm = true
						res["jieduan"] = Array.isArray(res["jieduan"]) ? res["jieduan"] : res["jieduan"].split(",");
						this.action={ type: 'update',relevant:relevant,actiontype:actiontype }
						this.formData = JSON.parse(JSON.stringify(res))
						break;
				}
			}
		}
	};
</script>
<style scoped>
	.shitu-box {
		margin-top: 10px;
		padding: 10px;
		background-color: #fff;
		width: 1200px;
		font-size: 15px;
	}
	/deep/ .p-contianer{
		background-color: #fff !important;
		padding:10px
	}
	/deep/ .table-head-name{
		display: inline;
	}
	/deep/ .el-table  {
	  overflow: visible;
	}
	 
	/deep/ .el-table__header-wrapper {
	  position: sticky;
	  top: 50px;
	  z-index: 10;
	}
	.icon, .customer-lock{
		cursor: pointer;
		font-size: 15px;
	}
	.customer-lock {
		color: #f15e64;
	}
	/deep/ .el-link{
		font-size: 12px !important;
	}
	.heise{
		color:#333 !important;
	}
	/deep/ .el-tag{
		/* color:#333 !important; */
		/* width: 85px !important; */
		overflow: hidden;
		text-align: center;
		padding:0 !important
	}
	/deep/ .el-table .el-table__cell {
	    padding: 3px 0 !important;
	}
</style>